import { render } from "./LexWeb.vue?vue&type=template&id=50a86736&scoped=true"
import script from "./LexWeb.vue?vue&type=script&lang=js"
export * from "./LexWeb.vue?vue&type=script&lang=js"

import "./LexWeb.vue?vue&type=style&index=0&id=50a86736&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50a86736"],['__file',"src/components/LexWeb.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "50a86736"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('50a86736', __exports__)) {
    api.reload('50a86736', __exports__)
  }
  
  module.hot.accept("./LexWeb.vue?vue&type=template&id=50a86736&scoped=true", () => {
    api.rerender('50a86736', render)
  })

}


export default __exports__